function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect, useState } from 'react';
import { ErrorType } from "../VendorOnboardingModal.utils";
import styles from "./SavingStep.module.scss";
import { useStore, useStoreActions } from "../../../store/store-context";
import { Button, Spinner, Typography } from 'seagull';
import { useEventReporter } from "../../../event-reporter";
import ContactSupportButton from "../../ContactSupportButton";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
var SavingState;

(function (SavingState) {
  SavingState["Idle"] = "idle";
  SavingState["Saving"] = "saving";
  SavingState["Error"] = "error";
  SavingState["Success"] = "success";
})(SavingState || (SavingState = {}));

function parseStripeError(data) {
  if (data && typeof data === 'object' && 'error' in data) {
    try {
      const parsed = JSON.parse(data['error']);

      if (parsed['doc_url']) {
        return parsed;
      }
    } catch (_unused) {
      return null;
    }
  }

  return null;
}

export function SavingStep(props) {
  const {
    vobData,
    onSavingSuccess,
    onErrorBackButton
  } = props;
  const userInfo = useStore(state => state.userInfo);
  const [savingState, setSavingState] = useState(SavingState.Idle);
  const [errorType, setErrorType] = useState();
  const [failureMsg, setFailureMsg] = useState('Something unexpected happened');
  const {
    api,
    setUserInfo,
    setAuthToken,
    updateUserClientData,
    fetchUserInfo
  } = useStoreActions();
  const {
    reportToHubspot,
    reportToAppcues
  } = useEventReporter();
  useEffect(() => {
    setSavingState(SavingState.Saving);
    reportToAppcues('form-success', 'onboarding-signed-up');
    reportToHubspot('onboarding_signed_up', _objectSpread({
      email: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email
    }, vobData));
    saveVobData().then(() => fetchUserInfo()).then(() => {
      setSavingState(SavingState.Success);
      onSavingSuccess(true);
    }).catch(err => {
      var _err$response;

      const stripeError = parseStripeError((_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.data);

      if (stripeError) {
        setErrorType(ErrorType.Stripe);
        setFailureMsg(stripeError.message);
      } else {
        setErrorType(ErrorType.General);
      }

      setSavingState(SavingState.Error);
    });
  }, []);

  async function saveVobData() {
    // update user info
    const editUserDetailsRes = await api.auth.editUserDetails({
      phone: vobData.phone,
      name: vobData.name
    });
    setUserInfo(_objectSpread(_objectSpread({}, userInfo), editUserDetailsRes)); // update/create vendor business

    const businessData = {
      name: vobData.companyName,
      businessType: vobData.businessTypes[0],
      businessTypes: vobData.businessTypes,
      businessTypeOther: vobData.businessTypeOther || null,
      postalAddress: vobData.postalAddress
    };
    const hasUserBusiness = Boolean(userInfo === null || userInfo === void 0 ? void 0 : userInfo.worksAt);

    if (hasUserBusiness) {
      await api.vendor.update(businessData);
    } else {
      var _createVendorResponse;

      const createVendorResponse = await api.vendor.create(businessData);

      if ((createVendorResponse === null || createVendorResponse === void 0 ? void 0 : (_createVendorResponse = createVendorResponse.data) === null || _createVendorResponse === void 0 ? void 0 : _createVendorResponse.authToken) != null) {
        await setAuthToken(createVendorResponse.data.authToken);
      }
    } // update client data


    await updateUserClientData({
      'onboarding-num-clients': parseInt(vobData.numOfInvoices)
    }, {
      useLocalData: true
    });
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, savingState === SavingState.Saving ? /*#__PURE__*/React.createElement(SavingData, null) : null, savingState === SavingState.Error ? /*#__PURE__*/React.createElement(ErrorState, {
    onErrorBackButton: onErrorBackButton,
    failureMsg: failureMsg,
    errorType: errorType
  }) : null);
}

function SavingData() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.savingContainer,
    "data-testid": "vob-saving"
  }, /*#__PURE__*/React.createElement(Spinner, null), /*#__PURE__*/React.createElement(Typography, null, "Setting up your account"));
}

function ErrorState(props) {
  const {
    onErrorBackButton,
    failureMsg,
    errorType
  } = props;
  const {
    CONTACT_SUPPORT
  } = useFeatureFlags();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.errorContainer,
    "data-testid": "vob-error"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "vob-failure-reason",
    variant: CONTACT_SUPPORT ? 'h4' : 'h3'
  }, failureMsg), /*#__PURE__*/React.createElement(Typography, {
    variant: CONTACT_SUPPORT ? undefined : 'h6',
    skin: "secondary"
  }, "Click", ' ', /*#__PURE__*/React.createElement(Typography, {
    as: "span",
    variant: CONTACT_SUPPORT ? undefined : 'h6',
    weight: "bold"
  }, "Back"), ' ', "to try again or", ' ', CONTACT_SUPPORT ? /*#__PURE__*/React.createElement(ContactSupportButton, null) : /*#__PURE__*/React.createElement(React.Fragment, null, "contact ", /*#__PURE__*/React.createElement("a", {
    href: "mailto:support@sayanchor.com"
  }, "support@sayanchor.com")), ".")), /*#__PURE__*/React.createElement("div", {
    className: styles.footer,
    onClick: () => {
      onErrorBackButton(errorType);
    }
  }, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "vob-error-back-btn"
  }, "Back")));
}